import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16 4A12 12 0 114 16 12 12 0 0116 4m0-2a14 14 0 1014 14A14 14 0 0016 2z"/><path d="M21.2 9.4L18.3 9a1 1 0 00-1 .6l-1 3.1a.9.9 0 00.4 1l1.6 1a5.1 5.1 0 01-2.5 3.8l-1.4-1.2a.9.9 0 00-1-.1l-3 1.5a.9.9 0 00-.3 1l.9 2.8a.9.9 0 001 .6c7-.7 10.6-6 10-13a.8.8 0 00-.8-.7z"/>';
export var PhoneCircleOutlineSVG = function PhoneCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PhoneCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PhoneCircleOutlineSVG);